// src/components/ForgotPassword.js
import React, { useState } from "react";
import { auth } from "../firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  // 发送重置密码邮件
  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!email) {
      setErrorMsg("请输入注册时的邮箱 / Please enter your registered email");
      return;
    }
    if (loading) return;

    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    try {
      // Firebase 自动发送重置密码邮件
      await sendPasswordResetEmail(auth, email, {
        // 自定义重置密码页面（部署后替换为你的域名）
        url: process.env.NODE_ENV === "production" 
          ? "https://winedefull.com/reset-password" 
          : "http://localhost:3001/reset-password"
      });
      
      setSuccessMsg("重置密码邮件已发送！请查收邮箱（含垃圾邮件）/ Password reset email sent! Check your inbox (including spam)");
      // 3秒后跳转到登录页
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      console.error("发送重置邮件失败:", err);
      let msg = "发送失败 / Send failed: ";
      if (err.code === "auth/user-not-found") {
        msg += "该邮箱未注册 / Email not registered";
      } else if (err.code === "auth/invalid-email") {
        msg += "邮箱格式错误 / Invalid email format";
      } else {
        msg += err.message;
      }
      setErrorMsg(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-pink-50 via-rose-50 to-rose-100 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-6">
        <h1 className="text-2xl font-semibold mb-4" style={{ color: "#C86B85" }}>
          📧 Forgot Password / 找回密码
        </h1>

        {/* 提示信息 */}
        {successMsg && (
          <div className="mb-4 p-2 bg-green-100 text-green-700 rounded-lg text-center">
            {successMsg}
          </div>
        )}
        {errorMsg && (
          <div className="mb-4 p-2 bg-red-100 text-red-700 rounded-lg text-center">
            {errorMsg}
          </div>
        )}

        {/* 找回密码表单 */}
        <form onSubmit={handleResetPassword}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
            placeholder="Enter your registered email / 输入注册邮箱"
            className="w-full border border-gray-200 rounded-lg px-4 py-2 mb-6 focus:outline-none focus:ring-2 focus:ring-pink-200"
            disabled={loading}
            required
          />

          <button
            type="submit"
            className={`w-full py-2 rounded-lg text-white font-semibold ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
            style={{ background: "linear-gradient(90deg,#F7C6D4,#F4D19B)" }}
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Reset Email / 发送重置邮件"}
          </button>
        </form>

        {/* 跳转链接 */}
        <div className="mt-4 text-center text-gray-600">
          <Link to="/login" className="text-pink-600 hover:underline">
            ← Back to Login / 返回登录
          </Link>
          <br />
          <Link to="/register" className="text-pink-600 hover:underline mt-2 inline-block">
            Don't have an account? Register / 没有账号？注册
          </Link>
        </div>
      </div>
    </div>
  );
}